import React from 'react'

const MainTemplate: React.FC = ({ children }: any) => (
  <>
    {children}
  </>
)

export default MainTemplate
